/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-tagless-components */
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import { computed } from '@ember/object';
import { service } from '@ember/service';

export default class HubspotContent extends Component {
  @service
  hubspotLinks;

  // Properties
  // Attributes
  @tracked linkId = null; // This will be set by the template

  @computed('hubspotLinks.modifiedURLs')
  get modifiedURLs() {
    return this.get('hubspotLinks.modifiedURLs');
  }

  @computed('linkId', 'hubspotLinks.modifiedURLs')
  get upgradedUrl() {
    let linkId = this.linkId;
    let urls = this.get('hubspotLinks.modifiedURLs');
    let selectedUrlObj = urls.find((urlObj) => urlObj.id === linkId);
    return selectedUrlObj ? selectedUrlObj.url : null;
  }
}
